import { useState, useEffect } from "react";
import { StyleSheet, View, Text, TextInput } from 'react-native';
import { AdaptedButton } from "../../components/adaptedButton";

export function Page1({ handleClick }) {
  const [nameValue, setNameValue] = useState("");
  const [zipcode, setZipcode] = useState("");

  const handleNameChange = (event) => {
    setNameValue(event);
  };

  useEffect(() => {
    handleClick('name', { nameValue })
  }, [nameValue]);

  const handleZipcodeChange = (event) => {
    setZipcode(event);
  };

  useEffect(() => {
    handleClick('zipcode', { zipcode })
  }, [zipcode]);

  const [selectedValue, setSelectedValue] = useState('');
  const handleButtonClick = (name, value) => {
    setSelectedValue(value)
    handleClick(name, value);
  };

  return (
    <View style={styles.container}>
      <Text style={styles.questionText}>What is your first name?</Text>
      <View style={styles.inputContainer}>
        <TextInput
          style={styles.input}
          //placeholder="First and last"
          value={nameValue}
          onChangeText={handleNameChange}
        />
      </View>
      <Text style={styles.questionText}>Where are you located?</Text>
      <View style={styles.inputContainer}>
        <TextInput
          style={styles.input}
          placeholder="Zip Code"
          value={zipcode}
          onChangeText={handleZipcodeChange}
        />
      </View>

    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    //flexDirection: 'row',
    //justifyContent: 'space-between',
    //marginBottom: 5,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  button: {
    backgroundColor: '#EFE7DE',
    padding: 5,
    borderRadius: 10,
    borderWidth: 4,
    borderColor: '#EFE7DE',
    marginHorizontal: 10,
    marginVertical: 10,
    width: "50%"
  },
  title: {
    position: 'fixed',
    top: '29%',
    left: '50%',
    transform: 'translateX(-50%)',
    margin: 10
  },
  questionText: {
    color: '#3B1C15',
    fontSize: 20,
    fontFamily: 'DM Sans',
    
    //fontWeight: 'bold',
  },
  inputContainer: {
    paddingHorizontal: 10,
    margin: 10,
    width: 300
  },
  input: {
    fontSize: 20,
    color: '#3B1C1580',
    backgroundColor: '#EFE7DE',
    textAlign: 'center',
    padding: 5,
    width: 300,
    fontFamily: 'DM Sans',

  },
  component: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //margin: 20,
    width: '100%',
    alignSelf: 'stretch',
  },
});